import paymentMethodTypes from 'common/constants/paymentMethodTypes'
import { useStripeGeneralPaymentHandler } from 'publisher/hooks/payment/use-stripe-general-payment-handler'
import useCashOnDeliveryPaymentHandler from 'publisher/hooks/payment/useCashOnDeliveryPaymentHandler'
import useDLocalBoletoAndPixPaymentHandler from 'publisher/hooks/payment/useDLocalBoletoAndPixPaymentHandler'
import useDLocalPaymentHandler from 'publisher/hooks/payment/useDLocalPaymentHandler'
import useFlutterwavePaymentHandler from 'publisher/hooks/payment/useFlutterwavePaymentHandler'
import useGocardlessPaymentHandler from 'publisher/hooks/payment/useGocardlessPaymentHandler'
import useMercadoPagoPaymentHandler from 'publisher/hooks/payment/useMercadoPagoPaymentHandler'
import useMercadoPagoTaxNumberPaymentHandler from 'publisher/hooks/payment/useMercadoPagoTaxNumberPaymentHandler'
import useMolliePaymentHandler from 'publisher/hooks/payment/useMolliePaymentHandler'
import usePaypalPaymentHandler from 'publisher/hooks/payment/usePaypalPaymentHandler'
import usePaystackPaymentHandler from 'publisher/hooks/payment/usePaystackPaymentHandler'
import useRazorpayPaymentHandler from 'publisher/hooks/payment/useRazorpayPaymentHandler'
import useSecureAndPayPaymentHandler from 'publisher/hooks/payment/useSecureAndPayPaymentHandler'
import useStripeBancontactPaymentHandler from './useStripeBancontactPaymentHandler'
import useStripeCardPaymentHandler from './useStripeCardPaymentHandler'
import useXenditPaymentHandler from './useXenditPaymentHandler'

const {
  STRIPE_CARD,
  STRIPE_IDEAL,
  PAYPAL_SOAP,
  STRIPE_BANCONTACT,
  DLOCAL_BOLETO,
  DLOCAL_CARD,
  DLOCAL_PIX,
  MERCADO_PAGO_CARD,
  MERCADO_PAGO_PIX,
  MERCADO_PAGO_BOLETO,
  MERCADO_PAGO_BR_BOLETO,
  MERCADO_PAGO_BR_PIX,
  MERCADO_PAGO_BR_CARD,
  MERCADO_PAGO_CO_CARD,
  MERCADO_PAGO_MX_CARD,
  MERCADO_PAGO_AR_CARD,
  RAZORPAY,
  FLUTTERWAVE,
  MOLLIE,
  GOCARDLESS,
  CASH_ON_DELIVERY,
  PAYSTACK_GH_CARD,
  PAYSTACK_KE_CARD,
  PAYSTACK_NG_CARD,
  PAYSTACK_ZA_CARD,
  PAYSTACK_EG_CARD,
  PAYSTACK_CI_CARD,
  MERCADO_PAGO_CL_CARD,
  SECURE_AND_PAY,
  XENDITIDCARD,
  XENDITPHCARD,
  STRIPE_KLARNA,
  STRIPE_MULTIBANCO,
} = paymentMethodTypes

export const usePaymentHandlerByProvider = (
  provider: keyof typeof paymentMethodTypes,
) => {
  switch (provider) {
    //https://app.shortcut.com/systeme/story/73336/revert-stripe
    //     case STRIPE_CARD:
    // case STRIPE_GENERAL:
    // case STRIPE_IDEAL:
    // case STRIPE_BANCONTACT:
    //   return useStripeGeneralPaymentHandler
    case STRIPE_CARD:
      return useStripeCardPaymentHandler
    case STRIPE_BANCONTACT:
    case STRIPE_IDEAL:
    case STRIPE_KLARNA:
    case STRIPE_MULTIBANCO:
      return useStripeGeneralPaymentHandler
    case PAYPAL_SOAP:
      return usePaypalPaymentHandler
    case DLOCAL_CARD:
      return useDLocalPaymentHandler
    case DLOCAL_PIX:
    case DLOCAL_BOLETO:
      return useDLocalBoletoAndPixPaymentHandler
    case MERCADO_PAGO_CARD:
    case MERCADO_PAGO_BR_CARD:
    case MERCADO_PAGO_CO_CARD:
    case MERCADO_PAGO_MX_CARD:
    case MERCADO_PAGO_AR_CARD:
    case MERCADO_PAGO_CL_CARD:
      return useMercadoPagoPaymentHandler
    case MERCADO_PAGO_PIX:
    case MERCADO_PAGO_BOLETO:
    case MERCADO_PAGO_BR_BOLETO:
    case MERCADO_PAGO_BR_PIX:
      return useMercadoPagoTaxNumberPaymentHandler
    case RAZORPAY:
      return useRazorpayPaymentHandler
    case FLUTTERWAVE:
      return useFlutterwavePaymentHandler
    case MOLLIE:
      return useMolliePaymentHandler
    case GOCARDLESS:
      return useGocardlessPaymentHandler
    case CASH_ON_DELIVERY:
      return useCashOnDeliveryPaymentHandler
    case SECURE_AND_PAY:
      return useSecureAndPayPaymentHandler
    case PAYSTACK_GH_CARD:
    case PAYSTACK_KE_CARD:
    case PAYSTACK_NG_CARD:
    case PAYSTACK_ZA_CARD:
    case PAYSTACK_EG_CARD:
    case PAYSTACK_CI_CARD:
      return usePaystackPaymentHandler
    case XENDITIDCARD:
    case XENDITPHCARD:
      return useXenditPaymentHandler
    default:
      return
  }
}
